import * as React from 'react';
import { compose } from 'recompose';
import { Header as MicroHeader } from '@unitedtraders/header-microfrontend';
import { passApplication } from '@unitedtraders/application-bootstrapper';
import { translate } from '../../utils/translateUtils';

const enhance = compose(translate, passApplication);

const HeaderView = ({ application, lng, ...props }) => {
  const { authorization, settings, history } = application;

  const appConfig = {
    graphqlGateway: settings.get('graphqlGateway')
  };

  const goTo = pathname => (window.location.href = pathname);

  const push = pathname => {
    history.push(
      `${window.location.pathname}/${pathname}`.replace(/\/{2,}/g, '/').replace(/\/$/, '')
    );
  };

  const cfg = {
    isAuthorized: authorization.isAuthenticated(),
    locale: lng,
    featureFlags: {},
    getTokens: () => authorization.getTokens(),
    onLogin: () => push('/auth/login'),
    onRegistration: () => push('/auth/registration'),
    openDepositModal: () => push('/deposit'),
    openWithdrawModal: () => push('/withdraw'),
    openSideMenu: () => null,
    navigateTo: goTo,

    appConfig,
    loginWith2FARecomendation: {
      isVisible: false,
      hide: () => null
    }
  };

  return (
    <div>
      <MicroHeader {...cfg} {...props} />
    </div>
  );
};

export const Header = enhance(HeaderView);



// WEBPACK FOOTER //
// ./src/components/Header/index.js